import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {Radio} from 'shells/radio/radio';
import {RadioButton} from 'shells/radio/radio-button';
import {RadioGroup} from 'shells/radio/radio-group';
import {Body} from 'shells/typography/body';

import type {FormFieldSubfieldsInput as Subfield} from 'nutshell-graphql-types';

import {AddressFieldsCheckboxGroup} from './address-fields-checkbox-group';

export type Props = {
    control: Control;
    name: string;
    watch: Watch;
    onEditAddressMultiFields: (
        updatedFields?: Subfield[],
        updatedIsSeparateFields?: boolean
    ) => void;
    useSmallCheckboxes?: boolean;
    useSmallRadioButtons?: boolean;
};

const RADIO_VALUES = {
    SINGLE_FIELD: 'single_field',
    SEPARATE_FIELDS: 'separate_fields',
} as const;

export function AddressTypeSelector(props: Props) {
    const isSeparateFields = props.watch(`${props.name}.isSeparateFields`);

    const RadioComponent = props.useSmallRadioButtons ? Radio : RadioButton;

    return (
        <>
            <Body size='small'>
                Customize the way people input their address, whether through autocomplete
                suggestions, or separate address fields.
            </Body>
            <Controller
                name={`${props.name}.isSeparateFields`}
                control={props.control}
                // @ts-expect-error
                render={({field}) => {
                    return (
                        <div className='full-width pt-16'>
                            <RadioGroup
                                name='buttons'
                                selectedValue={
                                    isSeparateFields
                                        ? RADIO_VALUES.SEPARATE_FIELDS
                                        : RADIO_VALUES.SINGLE_FIELD
                                }
                                onChange={(newVal) => {
                                    field.onChange(newVal === RADIO_VALUES.SEPARATE_FIELDS);
                                    props.onEditAddressMultiFields(
                                        undefined,
                                        newVal === RADIO_VALUES.SEPARATE_FIELDS
                                    );
                                }}
                            >
                                {/* @ts-expect-error */}
                                <RadioComponent value={RADIO_VALUES.SINGLE_FIELD}>
                                    Autocomplete address field
                                </RadioComponent>
                                {/* @ts-expect-error */}
                                <RadioComponent value={RADIO_VALUES.SEPARATE_FIELDS}>
                                    Separate address fields
                                </RadioComponent>
                            </RadioGroup>
                            {isSeparateFields && (
                                <AddressFieldsCheckboxGroup
                                    name={props.name}
                                    control={props.control}
                                    watch={props.watch}
                                    onEditAddressMultiFields={props.onEditAddressMultiFields}
                                    isSmall={props.useSmallCheckboxes}
                                />
                            )}
                        </div>
                    );
                }}
            />
        </>
    );
}
